import { Injectable } from '@angular/core';
import { State, StateToken, Action, StateContext } from '@ngxs/store';
import { RefreshState } from '../refresh/refresh-actions';
import { SetAuthentication, DeleteAuthentication } from './auth-actions';

const AUTHENTICATION_TOKEN = new StateToken<any>('authentication');

@State({
    name: AUTHENTICATION_TOKEN,
    defaults: null
})
@Injectable()
export class AuthState {
    @Action(RefreshState)
    refresh(ctx: StateContext<any[]>, action: RefreshState) {
        if (action.data.name === AUTHENTICATION_TOKEN.getName()) {
            ctx.setState(action.data.state);
        }
    }

    @Action(SetAuthentication)
    setAuthentication(ctx: StateContext<any>, action: SetAuthentication) {
        ctx.setState(action.authenticationInfo);
    }

    @Action(DeleteAuthentication)
    deleteAuthentication(ctx: StateContext<any>) {
        ctx.setState(null);
    }
}
